import * as React from 'react';
import AccountsByFundGroupCore from '../FundGroupOrientation/AccountsByFundGroupCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';

const AccountsByProprietaryA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AccountsByFundGroupCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser}
                fundGroup="Proprietary"
                noData="workState_noProprietaryFunds"
                done="workState_proprietaryFundsComplete"
                reviewed="reviewState_proprietaryFundsReviewed"
            />
        </React.Fragment>
    );
}

export default AccountsByProprietaryA;